module.exports = __webpack_public_path__ + "static/media/cta-planner-card-icon.b7df5316.PNG";